import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33cb4483"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex-1 flex flex-row flex-nowrap gap-4" }
const _hoisted_2 = { class: "min-w-[240px] max-w-[240px] flex flex-col place-content-between gap-4" }
const _hoisted_3 = { class: "header gap-1 flex flex-col" }
const _hoisted_4 = { class: "gordita-400-13 text-Text/text_medium" }
const _hoisted_5 = {
  class: "gordita-medium-500-20 text-Text/text_high",
  "data-testid": "total-tasks"
}
const _hoisted_6 = { class: "details grow flex flex-col w-full justify-center" }
const _hoisted_7 = {
  key: 0,
  class: "cache pb-4 border-b border-b-System/app_border",
  "data-testid": "cache-tasks"
}
const _hoisted_8 = { class: "flex flex-col gap-2" }
const _hoisted_9 = { class: "gordita-400-13 text-Text/text_medium" }
const _hoisted_10 = { class: "flex gordita-400-13 text-Text/text_high gap-1.5" }
const _hoisted_11 = {
  class: "gordita-medium-500-15",
  "data-testid": "cache-hits-percentage"
}
const _hoisted_12 = {
  class: "gordita-regular-400-15",
  "data-testid": "cache-hits"
}
const _hoisted_13 = { class: "remotely py-4 border-b border-b-System/app_border" }
const _hoisted_14 = { class: "flex flex-col gap-3" }
const _hoisted_15 = { class: "flex flex-col gap-1.5" }
const _hoisted_16 = { class: "gordita-400-13 text-Text/text_medium" }
const _hoisted_17 = { class: "gordita-400-13 text-Text/text_high" }
const _hoisted_18 = {
  class: "gordita-medium-500-15",
  "data-testid": "remote-tasks-percentage"
}
const _hoisted_19 = {
  class: "gordita-regular-400-15",
  "data-testid": "remote-tasks"
}
const _hoisted_20 = { class: "flex gap-1.5" }
const _hoisted_21 = { class: "gordita-400-12 text-Text/text_medium" }
const _hoisted_22 = {
  class: "gordita-400-13 text-Text/text_high",
  "data-testid": "distributed-tasks"
}
const _hoisted_23 = { class: "locally pt-4" }
const _hoisted_24 = { class: "flex flex-col gap-3" }
const _hoisted_25 = { class: "flex flex-col gap-1.5" }
const _hoisted_26 = { class: "gordita-400-13 text-Text/text_medium" }
const _hoisted_27 = { class: "gordita-400-13 text-Text/text_high" }
const _hoisted_28 = {
  class: "gordita-medium-500-15",
  "data-testid": "local-tasks-percentage"
}
const _hoisted_29 = {
  class: "gordita-regular-400-15",
  "data-testid": "local-tasks"
}
const _hoisted_30 = { class: "flex gap-1.5" }
const _hoisted_31 = { class: "gordita-400-12 text-Text/text_medium" }
const _hoisted_32 = {
  class: "gordita-400-13 text-Text/text_high",
  "data-testid": "non-distributed-tasks"
}
const _hoisted_33 = { class: "flex-1 pl-4 border-l border-System/app_border min-h-[60px]" }
const _hoisted_34 = { class: "flex flex-col gap-4" }
const _hoisted_35 = { class: "long-task-header gordita-400-13 text-Text/text_medium" }
const _hoisted_36 = { class: "gordita-500-12" }
const _hoisted_37 = { class: "gordita-500-12" }
const _hoisted_38 = { class: "gordita-500-12 grow" }
const _hoisted_39 = { class: "gordita-500-12" }
const _hoisted_40 = { class: "gordita-500-12 truncate" }
const _hoisted_41 = { style: { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' } }
const _hoisted_42 = { class: "gordita-500-12" }
const _hoisted_43 = { class: "mx-3 gordita-400-12 text-Text/text_high content-center" }
const _hoisted_44 = { class: "mx-3 overflow-auto content-center" }
const _hoisted_45 = { class: "gordita-400-12 text-Text/text_high truncate" }
const _hoisted_46 = { class: "gordita-400-12" }
const _hoisted_47 = { class: "mx-3 overflow-auto content-center" }
const _hoisted_48 = { class: "gordita-400-12 text-Text/text_high truncate" }
const _hoisted_49 = { class: "gordita-400-12" }
const _hoisted_50 = { class: "mx-3 gordita-500-13 text-Text/text_high content-center" }
const _hoisted_51 = { class: "mx-3 gordita-500-13 text-Text/text_high content-center" }

import { ref } from 'vue';
import { IncrediChartBar, IncrediTable, IncrediTooltip } from 'incredi-ui';
import { Maybe } from 'graphql/jsutils/Maybe';
import IbxScopedCss from '@/components/IbxScopedCss/IbxScopedCss.vue';
import COLORS from '@/design-system/colors.json';
import { formatNumber } from '@/services/utils';
import { convertBaseTimeToSSMMHH } from '@/views/dashboard/dashboard.charts.utils';
import { useKeyGenRerender } from './key-gen-rerender';

type Distribution = {
  failure: Maybe<number>;
  warning: Maybe<number>;
  success: Maybe<number>;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'workload-view-performance-tasks',
  props: {
    tasks: null,
    isBuildCache: { type: Boolean },
    totalTasks: null,
    localTasks: null,
    remoteTasks: null,
    cacheTaskHits: null,
    cacheTaskHitsPercentage: null,
    remoteTasksPercentage: null,
    localTasksPercentage: null,
    distributableTasks: null,
    nonDistributableTasks: null,
    longestTasks: null
  },
  setup(__props: any) {

const percentHeaderTooltip = ref();
const cellTooltip = ref([[], []]);

const barChartKey = useKeyGenRerender('barChart_');

const columns = [
  { name: 'taskId', width: 80 },
  { name: 'taskMachineName', minWidth: 125 },
  { name: 'taskName', minWidth: 125 },
  { name: 'duration', width: 112 },
  { name: 'percentage', width: 104 },
];

const gridTemplateColumns = columns.map(({ width, minWidth }) => (width ? `${width}px` : `minmax(${minWidth || 0}px, auto)`)).join(' ');



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IbxScopedCss, { class: "workload-view-performance-tasks flex flex-row flex-nowrap gap-4 w-full" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('workloads.details.performanceMetricsTab.tasks.totalTasks')), 1),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(formatNumber)(__props.totalTasks || 0)), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (__props.isBuildCache)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('workloads.details.performanceMetricsTab.tasks.executedFromCache')), 1),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(__props.cacheTaskHitsPercentage || 0) + "% ", 1),
                      _createElementVNode("span", _hoisted_12, " (" + _toDisplayString(__props.cacheTaskHits) + ") ", 1)
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('workloads.details.performanceMetricsTab.tasks.executedRemotely')), 1),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("span", _hoisted_18, _toDisplayString(__props.remoteTasksPercentage || 0) + "% ", 1),
                    _createElementVNode("span", _hoisted_19, " (" + _toDisplayString(_unref(formatNumber)(__props.remoteTasks || 0)) + ") ", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.$t('workloads.details.performanceMetricsTab.tasks.distributableTasks')), 1),
                  _createElementVNode("span", _hoisted_22, _toDisplayString(_unref(formatNumber)(__props.distributableTasks || 0)), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('workloads.details.performanceMetricsTab.tasks.executedLocally')), 1),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("span", _hoisted_28, _toDisplayString(__props.localTasksPercentage || 0) + "% ", 1),
                    _createElementVNode("span", _hoisted_29, " (" + _toDisplayString(_unref(formatNumber)(__props.localTasks || 0)) + ") ", 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.$t('workloads.details.performanceMetricsTab.tasks.nonDistributableTasks')), 1),
                  _createElementVNode("span", _hoisted_32, _toDisplayString(_unref(formatNumber)(__props.nonDistributableTasks || 0)), 1)
                ])
              ])
            ])
          ])
        ]),
        (_openBlock(), _createElementBlock("div", {
          key: _unref(barChartKey),
          class: "w-full"
        }, [
          _createVNode(_unref(IncrediChartBar), {
            "chart-id": "tasks-bar-chart",
            "data-testid": "tasks-bar-chart",
            "data-distribution": __props.isBuildCache ? 'cache, remote, local' : 'remote, local',
            "data-distribution-cache-success": __props.tasks.cache?.success || 0,
            "data-distribution-cache-warning": __props.tasks.cache?.warning || 0,
            "data-distribution-cache-failure": __props.tasks.cache?.failure || 0,
            "data-distribution-remote-success": __props.tasks.remote?.success || 0,
            "data-distribution-remote-warning": __props.tasks.remote?.warning || 0,
            "data-distribution-remote-failure": __props.tasks.remote?.failure || 0,
            "data-distribution-local-success": __props.tasks.local?.success || 0,
            "data-distribution-local-warning": __props.tasks.local?.warning || 0,
            "data-distribution-local-failure": __props.tasks.local?.failure || 0,
            height: "385px",
            options: {
            barWidth: 32,
            textStyle: {
              color: _unref(COLORS)['Text/text_low'],
              fontFamily: 'Gordita-Regular',
            },
            toolbox: {
              show: false,
            },
            grid: {
              bottom: 0,
              right: 10,
              left: 20,
            },
            xAxis: {
              type: 'category',
              data: (__props.isBuildCache ? [_ctx.$t('workloads.details.performanceMetricsTab.tasks.cache')] : []).concat([
                _ctx.$t('workloads.details.performanceMetricsTab.tasks.remote'),
                _ctx.$t('workloads.details.performanceMetricsTab.tasks.local'),
              ]),
              axisLine: {
                lineStyle: {
                  color: _unref(COLORS)['Text/text_low_old'],
                },
              },
              axisTick: { show: false },
            },
            yAxis: { type: 'value' },
            dataZoom: [{ show: false }],
            legend: {
              top: 0,
              right: 10,
              itemGap: 16,
            },
            tooltip: {
              backgroundColor: _unref(COLORS)['System/app_grey_22'],
              borderWidth: 0,
              textStyle: {
                color: _unref(COLORS)['System/app_white'],
                fontFamily: 'Gordita-Regular',
                fontSize: 12,
              },
            },
          },
            series: [
            {
              name: _ctx.$t('workloads.details.performanceMetricsTab.tasks.success'),
              itemStyle: { color: _unref(COLORS)['System/app_primary'] },
              type: 'bar',
              stack: 'tasks',
              data: (__props.isBuildCache ? [__props.tasks.cache?.success || 0] : []).concat([__props.tasks.remote?.success || 0, __props.tasks.local?.success || 0]),
              cursor: 'default',
            },
            {
              name: _ctx.$t('workloads.details.performanceMetricsTab.tasks.warning'),
              itemStyle: { color: _unref(COLORS)['System/app_warning'] },
              type: 'bar',
              stack: 'tasks',
              data: (__props.isBuildCache ? [__props.tasks.cache?.warning || 0] : []).concat([__props.tasks.remote?.warning || 0, __props.tasks.local?.warning || 0]),
              cursor: 'default',
            },
            {
              name: _ctx.$t('workloads.details.performanceMetricsTab.tasks.failure'),
              itemStyle: { color: _unref(COLORS)['Surface/surface_error_moderate'] },
              type: 'bar',
              stack: 'tasks',
              data: (__props.isBuildCache ? [__props.tasks.cache?.failure || 0] : []).concat([__props.tasks.remote?.failure || 0, __props.tasks.local?.failure || 0]),
              cursor: 'default',
            },
          ],
            labels: (__props.isBuildCache ? ['Cache'] : []).concat(['Remote', 'Local'])
          }, null, 8, ["data-distribution", "data-distribution-cache-success", "data-distribution-cache-warning", "data-distribution-cache-failure", "data-distribution-remote-success", "data-distribution-remote-warning", "data-distribution-remote-failure", "data-distribution-local-success", "data-distribution-local-warning", "data-distribution-local-failure", "options", "series", "labels"])
        ]))
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.$t('workloads.details.performanceMetricsTab.tasks.longestTasks.title')), 1),
          _createVNode(_unref(IncrediTable), {
            id: "longest-tasks-table",
            "data-testid": "longest-tasks-table",
            "grid-template-columns": _unref(gridTemplateColumns),
            resizable: false,
            data: [],
            columns: columns,
            "row-height": 32,
            "model-value": {},
            items: __props.longestTasks,
            "show-separators": false
          }, {
            "header-taskId": _withCtx(() => [
              _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.$t('workloads.details.performanceMetricsTab.tasks.longestTasks.taskId')), 1)
            ]),
            "header-taskMachineName": _withCtx(() => [
              _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.$t('workloads.details.performanceMetricsTab.tasks.longestTasks.taskMachineName')), 1)
            ]),
            "header-taskName": _withCtx(() => [
              _createElementVNode("div", _hoisted_38, _toDisplayString(_ctx.$t('workloads.details.performanceMetricsTab.tasks.longestTasks.taskName')), 1)
            ]),
            "header-duration": _withCtx(() => [
              _createElementVNode("div", _hoisted_39, _toDisplayString(_ctx.$t('workloads.details.performanceMetricsTab.tasks.longestTasks.duration')), 1)
            ]),
            "header-percentage": _withCtx(() => [
              _createVNode(_unref(IncrediTooltip), {
                modelValue: percentHeaderTooltip.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((percentHeaderTooltip).value = $event)),
                hover: "",
                delay: 200
              }, {
                content: _withCtx(() => [
                  _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.$t('workloads.details.performanceMetricsTab.tasks.longestTasks.percentage')), 1)
                ]),
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t('workloads.details.performanceMetricsTab.tasks.longestTasks.percentage')), 1)
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            "content-taskId": _withCtx(({ value: { taskId } }) => [
              _createElementVNode("div", _hoisted_43, _toDisplayString(taskId), 1)
            ]),
            "content-taskMachineName": _withCtx(({ value: { taskMachineName }, index }) => [
              _createElementVNode("div", _hoisted_44, [
                _createVNode(_unref(IncrediTooltip), {
                  modelValue: cellTooltip.value[0][index],
                  "onUpdate:modelValue": ($event: any) => ((cellTooltip.value[0][index]) = $event),
                  hover: "",
                  delay: 200
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_46, _toDisplayString(taskMachineName), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_45, _toDisplayString(taskMachineName), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"])
              ])
            ]),
            "content-taskName": _withCtx(({ value: { taskName }, index }) => [
              _createElementVNode("div", _hoisted_47, [
                _createVNode(_unref(IncrediTooltip), {
                  modelValue: cellTooltip.value[1][index],
                  "onUpdate:modelValue": ($event: any) => ((cellTooltip.value[1][index]) = $event),
                  hover: "",
                  delay: 200
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_49, _toDisplayString(taskName), 1)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_48, _toDisplayString(taskName), 1)
                  ]),
                  _: 2
                }, 1032, ["modelValue", "onUpdate:modelValue"])
              ])
            ]),
            "content-duration": _withCtx(({ value: { duration } }) => [
              _createElementVNode("div", _hoisted_50, _toDisplayString(_unref(convertBaseTimeToSSMMHH)(duration, 'ms') || _ctx.$t('generic.time.lessThanSecond')), 1)
            ]),
            "content-percentage": _withCtx(({ value: { durationPercentage } }) => [
              _createElementVNode("div", _hoisted_51, _toDisplayString(durationPercentage) + "%", 1)
            ]),
            _: 1
          }, 8, ["grid-template-columns", "items"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})